import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const MainAccountingIntegrationsRoutes = [
  {
    path: 'invoice-sync-items',
    name: 'invoice-sync-items',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      //   permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoice_sync_items],
      //   module: ModulesHelper.ACCOUNTING_INTEGRATIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "invoice-sync-items" */ '@accounting-integrations/pages/invoice-sync-items/invoice-sync-items.vue'
      ),
  },
  {
    path: 'sync-console',
    name: 'sync-console',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_sessions],
      module: ModulesHelper.POS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "sync-console" */ '@accounting-integrations/pages/sync-console-page.vue'
      ),
  },
];
